module.exports = __webpack_public_path__ + "img/new-york.51e35286.jpg";